const pickProperties = require('./pickProperties');

module.exports.run = (base, foreign, isMatch, foldKeys) => {

  return base.map(item => {
    
    const foreignItem = foreign.find(
      f => {
        return isMatch(f, item);
      }
    );
    if(!foreignItem){
      throw new Error('Foreign item not found');
    }

    return Object.assign(
      pickProperties.run(foreignItem, foldKeys),
      item
    );
  });
};